// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.courier-priority-tab {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.panel-container {
  display: flex;
  gap: 20px;
}

.panel {
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.active-inactive-panel {
  flex: 3 1;
}

.set-priority-panel {
  flex: 1 1;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.btn {
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  color: white;
  cursor: pointer;
}

.active-btn {
  background-color: red;
}

.inactive-btn {
  background-color: green;
}

.save-priority-btn {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #03C9D7;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  width: 100%; /* Makes the button full-width */
  box-sizing: border-box; /* Ensures padding doesn’t affect width */
}


.priority-list {
  margin-top: 10px;
}

.priority-item {
  padding: 10px;
  margin-bottom: 5px;
  background-color: #f9f9f9;
  border-radius: 5px;
  border: 1px solid #ddd;
  cursor: grab;
}

.priority-item:active {
  cursor: grabbing;
}

.message {
  margin-top: 10px;
  color: green;
}

.draggable-row {
  cursor: grab;
}

.draggable-row:active {
  cursor: grabbing;
  background-color: #f0f8ff;
}

.draggable-row:hover {
  background-color: #e6f7ff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CourierProcessTab3.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW,EAAE,gCAAgC;EAC7C,sBAAsB,EAAE,yCAAyC;AACnE;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".courier-priority-tab {\r\n  padding: 20px;\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.panel-container {\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.panel {\r\n  background: white;\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  padding: 20px;\r\n}\r\n\r\n.active-inactive-panel {\r\n  flex: 3;\r\n}\r\n\r\n.set-priority-panel {\r\n  flex: 1;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  border: 1px solid #ddd;\r\n  padding: 8px;\r\n  text-align: left;\r\n}\r\n\r\n.btn {\r\n  padding: 5px 10px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  color: white;\r\n  cursor: pointer;\r\n}\r\n\r\n.active-btn {\r\n  background-color: red;\r\n}\r\n\r\n.inactive-btn {\r\n  background-color: green;\r\n}\r\n\r\n.save-priority-btn {\r\n  margin-top: 10px;\r\n  padding: 10px 20px;\r\n  background-color: #03C9D7;\r\n  border: none;\r\n  color: white;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  width: 100%; /* Makes the button full-width */\r\n  box-sizing: border-box; /* Ensures padding doesn’t affect width */\r\n}\r\n\r\n\r\n.priority-list {\r\n  margin-top: 10px;\r\n}\r\n\r\n.priority-item {\r\n  padding: 10px;\r\n  margin-bottom: 5px;\r\n  background-color: #f9f9f9;\r\n  border-radius: 5px;\r\n  border: 1px solid #ddd;\r\n  cursor: grab;\r\n}\r\n\r\n.priority-item:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.message {\r\n  margin-top: 10px;\r\n  color: green;\r\n}\r\n\r\n.draggable-row {\r\n  cursor: grab;\r\n}\r\n\r\n.draggable-row:active {\r\n  cursor: grabbing;\r\n  background-color: #f0f8ff;\r\n}\r\n\r\n.draggable-row:hover {\r\n  background-color: #e6f7ff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
